export const LANGS = [
  { code: "tr", label: "Türkçe", short: "TR", dir: "ltr" },
  { code: "en", label: "English", short: "EN", dir: "ltr" },
  { code: "ru", label: "Русский", short: "RU", dir: "ltr" },
  { code: "ar", label: "العربية", short: "AR", dir: "rtl" },
];

export const translations = {
  tr: {
    nav: {
      home: "Ana Sayfa",
      packages: "Tarifeler",
      services: "Hizmetler",
      corporate: "Kurumsal",
      campaigns: "Kampanyalar",
      blog: "Blog",
      faq: "SSS",
      contact: "İletişim",
      online: "Online İşlemler",
      applyNow: "Hemen Başvur",
      applyOnline: "Online Başvuru",
      callYou: "Sizi Arayalım",
      coverage: "Altyapı Sorgula",
      individual: "Bireysel",
      speedTest: "Hız Testi",
      fastActions: "Hızlı İşlemler",
    },
    hero: {
      badge: "ORTACA'NIN AIR FİBER ALTYAPISI",
      title1: "Işık Hızında",
      title2: "İnternet.",
      subtitle:
        "ÇağrıNET ile eve kadar AIR Fiber teknolojisini keşfedin. 100 Mbps'e varan hız, sınırsız kota ve yerel teknik destek.",
      ctaPackages: "Tarifeleri İncele",
      ctaContact: "Bize Ulaşın",
      coverageTitle: "Altyapı Sorgula",
      coveragePlaceholder: "Mahalle / adresinizi yazın...",
      coverageBtn: "Sorgula",
      speedTestTitle: "İnternet Hız Testi",
      speedTestDesc: "Bağlantınızın gerçek hızını ölçün",
      speedTestStart: "Testi Başlat",
      speedTestRunning: "Ölçülüyor...",
      speedTestRetry: "Tekrar Test Et",
      speedTestDownload: "İndirme",
      speedTestUpload: "Yükleme",
      speedTestPing: "Gecikme (Ping)",
      speedTestJitter: "Titreşim (Jitter)",
      speedTestMbps: "Mbps",
      speedTestMs: "ms",
      speedTestLauncher: "Hız Testini Çalıştır",
      speedTestPoweredBy: "Fast altyapısı ile",
      speedTestNote: "Gerçek internet hızınızı güvenilir ve doğru şekilde ölçmek için tıklayın.",
      statSpeed: "Maksimum Hız",
      statSupport: "Teknik Destek",
      statUptime: "Çalışma Süresi",
      statLocal: "Yerel Hizmet",
      slide1Badge: "TAAHHÜTSÜZ & SINIRSIZ",
      slide1Title: "Sınırsız Hız,",
      slide1Title2: "Taahhütsüz İnternet",
      slide1Desc: "100 Mbps'e varan hız, sınırsız kota ve yerel teknik destek.",
      slide2Badge: "YEREL GÜÇ",
      slide2Title: "Ortaca'nın",
      slide2Title2: "AIR Fiber Altyapısı",
      slide2Desc: "Eve kadar AIR Fiber teknolojisi, komşu gibi hizmet anlayışı.",
      slide3Badge: "HEMEN BAĞLAN",
      slide3Title: "Hızlı Başvuru,",
      slide3Title2: "Hızlı Bağlantı",
      slide3Desc: "Bugün başvurun, 1-3 iş gününde AIR Fiber internetinize kavuşun.",
    },
    home: {
      statsTitle: "Rakamlarla ÇağrıNET",
      statsSubscribers: "Mutlu Abone",
      statsCoverage: "Kapsama Alanı",
      statsUptime: "Kesintisizlik",
      statsSupport: "Yerel Destek",
      whyTitle: "Neden ÇağrıNET?",
      whySubtitle: "Bölgenin en güçlü AIR Fiber altyapısını yerel hizmet anlayışıyla birleştiriyoruz.",
      why1Title: "Gerçek AIR Fiber Altyapı",
      why1Desc: "Eve kadar AIR Fiber (FTTH) ile taahhüt ettiğimiz hızı gerçekten alırsınız.",
      why2Title: "Sınırsız Kullanım",
      why2Desc: "Adil kullanım kotası yok. Dilediğiniz kadar indirin, izleyin, oynayın.",
      why3Title: "Yerel Destek",
      why3Desc: "Çağrı merkezi labirentleri yok. Ortaca'daki ekibimiz her an yanınızda.",
      why4Title: "Şeffaf Fiyatlandırma",
      why4Desc: "Gizli ücret yok, sürpriz zam yok. Ne ödediğinizi her zaman bilirsiniz.",
      packagesTitle: "Size Uygun Tarifeyi Seçin",
      packagesSubtitle: "Her ihtiyaca ve bütçeye uygun AIR Fiber internet paketleri.",
      allPackages: "Tüm Tarifeleri Gör",
      servicesTitle: "Hizmetlerimiz",
      servicesSubtitle: "Bireysel ve kurumsal tüm bağlantı ihtiyaçlarınız için tek adres.",
      campaignsTitle: "Güncel Kampanyalar",
      offerFeat1: "100 Mbps'e kadar indirme hızı",
      offerFeat2: "12 ay boyunca sabit fiyat garantisi",
      offerFeat3: "Taahhüt yok, istediğin zaman iptal et",
      offerFeat4: "e-Devlet ile anında dijital onay",
      ctaTitle: "Şirketimizce Altyapı İşletmeciliği Hizmeti (AİH) kapsamında herhangi bir elektronik haberleşme hizmeti sunulmamaktadır.",
      ctaSubtitle: "Bugün başvurun, 1-3 iş günü içinde AIR Fiber internetinize kavuşun.",
      ctaButton: "Hemen Başvur",
    },
    packages: {
      title: "Tarifeler",
      subtitle: "Sınırsız, taahhüt seçenekli ve şeffaf fiyatlı AIR Fiber internet paketleri.",
      perMonth: "/ay",
      popular: "EN POPÜLER",
      select: "Tarife Detayları",
      detailTitle: "Tarife Detayı",
      detailBack: "Tarifelere Dön",
      detailSpeed: "Bağlantı Hızı",
      detailPrice: "Aylık Ücret",
      detailFeatures: "Paket Özellikleri",
      detailCta: "Bu Tarifeye Başvur",
      detailSpeedDesc: "İndirme Hızı",
      detailPriceDesc: "KDV Dahil Aylık Sabit Ücret",
      detailFeaturesDesc: "Paketinize dahil olan tüm avantajlar",
      mbps: "Mbps",
      note: "Fiyatlara KDV ve ÖİV dahildir. Altyapı uygunluğuna göre hizmet verilmektedir.",
    },
    services: {
      title: "Hizmetler",
      subtitle: "Bireyselden kurumsala, eviniz ve işiniz için eksiksiz bağlantı çözümleri.",
    },
    about: {
      title: "Kurumsal",
      subtitle: "Bölgemizi geleceğin internetiyle buluşturuyoruz.",
      storyTitle: "Hikayemiz",
      p1: "ÇAĞRINETWORK İNTERNET İLETİŞİM HABERLEŞME LTD ŞTİ, Muğla'nın Ortaca ilçesinde kurulmuş, bölgesine yüksek hızlı ve güvenilir internet erişimi sunmayı amaç edinmiş bir internet servis sağlayıcısıdır.",
      p2: "Kurulduğumuz günden bu yana, büyük operatörlerin yeterince yatırım yapmadığı bölgelere modern AIR Fiber altyapı taşıyor; her haneye ve işletmeye büyük şehir kalitesinde internet hizmeti ulaştırıyoruz.",
      p3: "Yerel bir şirket olmanın gücüyle, abonelerimize sadece bir müşteri numarası gibi değil, komşumuz gibi davranıyoruz. Teknik ekibimiz aynı gün müdahale, mesai saatleri içinde destek ve şeffaf fiyatlandırma ilkeleriyle çalışır.",
      missionTitle: "Misyonumuz",
      missionText: "Bölgemizdeki her haneye ve işletmeye, hızlı, kesintisiz ve uygun fiyatlı internet erişimi sağlamak.",
      visionTitle: "Vizyonumuz",
      visionText: "Muğla ve çevresinin dijital dönüşümüne öncülük eden, en güvenilir bölgesel telekomünikasyon şirketi olmak.",
      valuesTitle: "Değerlerimiz",
      value1: "Güvenilirlik",
      value1Desc: "Verdiğimiz sözü tutarız; taahhüt ettiğimiz hızı sunarız.",
      value2: "Yerellik",
      value2Desc: "Bölgemizi tanırız, abonelerimize komşumuz gibi davranırız.",
      value3: "Yenilikçilik",
      value3Desc: "Altyapımızı sürekli geliştirir, en yeni teknolojiyi bölgemize taşırız.",
    },
    blog: {
      title: "Blog & Haberler",
      subtitle: "ÇağrıNET'ten haberler, teknoloji rehberleri ve duyurular.",
      readMore: "Devamını Oku",
      back: "Tüm Yazılar",
      empty: "Henüz yazı bulunmuyor.",
    },
    campaigns: {
      title: "Kampanyalar",
      subtitle: "Size özel fırsatları kaçırmayın.",
      apply: "Kampanyadan Yararlan",
      empty: "Şu anda aktif kampanya bulunmuyor.",
    },
    faq: {
      title: "Sıkça Sorulan Sorular",
      subtitle: "Merak ettikleriniz için hızlı yanıtlar.",
      moreTitle: "Sorunuzun yanıtını bulamadınız mı?",
      moreText: "Ekibimiz tüm sorularınız için mesai saatleri içinde hazır.",
      moreCta: "Bize Ulaşın",
    },
    contact: {
      title: "İletişim",
      subtitle: "Sorularınız, başvurularınız ve destek talepleriniz için buradayız.",
      formTitle: "Bize Yazın",
      name: "Ad Soyad",
      email: "E-posta",
      phone: "Telefon",
      subject: "Konu",
      message: "Mesajınız",
      send: "Gönder",
      sending: "Gönderiliyor...",
      success: "Mesajınız başarıyla iletildi. En kısa sürede dönüş yapacağız.",
      error: "Mesaj gönderilemedi. Lütfen tekrar deneyin.",
      infoTitle: "İletişim Bilgileri",
      addressLabel: "Adres",
      phoneLabel: "Telefon",
      emailLabel: "E-posta",
      hoursLabel: "Çalışma Saatleri",
      hours: "Pazartesi - Cumartesi: 09.00 - 18.00",
    },
    footer: {
      tagline: "Ortaca ve çevresine yüksek hızlı AIR Fiber internet. Yerel güç, küresel hız.",
      quickLinks: "Hızlı Bağlantılar",
      services: "Hizmetler",
      contact: "İletişim",
      rights: "Tüm hakları saklıdır.",
    },
    cookie: {
      title: "Çerez Kullanıyoruz",
      text: "Web sitemizde daha iyi bir deneyim sunabilmek amacıyla çerezler (cookie) kullanılmaktadır. 6698 sayılı KVKK ve aydınlatma yükümlülüğü kapsamında, çerez kullanımımızı kabul edebilir veya ayarlarınızı yönetebilirsiniz.",
      policyLink: "Çerez Politikası",
      acceptAll: "Tümünü Kabul Et",
      reject: "Yalnızca Gerekli Çerezler",
      settings: "Ayarlar",
      close: "Kapat",
      catNecessary: "Gerekli Çerezler",
      catNecessaryDesc: "Web sitesinin düzgün çalışması için zorunludur. Devre dışı bırakılamaz.",
      catAnalytics: "Analitik Çerezler",
      catAnalyticsDesc: "Site kullanımını analiz etmek ve deneyimi iyileştirmek için kullanılır.",
      catMarketing: "Pazarlama Çerezleri",
      catMarketingDesc: "İlgi alanınıza uygun içerik ve reklamlar sunmak için kullanılır.",
      save: "Ayarları Kaydet",
      poweredBy: "KVKK ve GDPR uyumlu",
    },
    common: {
      loading: "Yükleniyor...",
    },
    comingSoon: {
      badge: "YAPIM AŞAMASINDA",
      title1: "Yenilenen Dijital",
      title2: "Deneyimimiz",
      subtitle:
        "Kurumsal web sitemiz üzerinde titizlikle çalışıyoruz. Yeni yüzümüz hazırlanana dek hizmetlerimiz kesintisiz devam ediyor.",
      paymentBtn: "Ödeme Yapmak İçin Tıklayınız",
      paymentNote: "Online ödeme sistemine güvenle yönlendirilirsiniz.",
      contactTitle: "Bize Ulaşın",
      brandTagline: "Ortaca'nın AIR Fiber altyapısı — yerel güç, küresel hız.",
    },
  },

  en: {
    nav: {
      home: "Home",
      packages: "Plans",
      services: "Services",
      corporate: "About Us",
      campaigns: "Campaigns",
      blog: "Blog",
      faq: "FAQ",
      contact: "Contact",
      online: "Online Services",
      applyNow: "Apply Now",
      applyOnline: "Apply Online",
      callYou: "Call You Back",
      coverage: "Check Coverage",
      individual: "Individual",
      speedTest: "Speed Test",
      fastActions: "Quick Actions",
    },
    hero: {
      badge: "ORTACA'S FIBER INFRASTRUCTURE",
      title1: "Internet at the",
      title2: "Speed of Light.",
      subtitle:
        "Discover AIR Fiber-to-the-home technology with ÇağrıNET. Speeds up to 100 Mbps, unlimited quota and local technical support.",
      ctaPackages: "View Plans",
      ctaContact: "Contact Us",
      coverageTitle: "Check Coverage",
      coveragePlaceholder: "Enter your neighborhood / address...",
      coverageBtn: "Check",
      speedTestTitle: "Internet Speed Test",
      speedTestDesc: "Measure your real connection speed",
      speedTestStart: "Start Test",
      speedTestRunning: "Measuring...",
      speedTestRetry: "Test Again",
      speedTestDownload: "Download",
      speedTestUpload: "Upload",
      speedTestPing: "Ping",
      speedTestJitter: "Jitter",
      speedTestMbps: "Mbps",
      speedTestMs: "ms",
      speedTestLauncher: "Start Speed Test",
      speedTestPoweredBy: "Powered by Fast.com",
      speedTestNote: "Click to measure your real internet speed reliably and accurately.",
      statSpeed: "Maximum Speed",
      statSupport: "Technical Support",
      statUptime: "Uptime",
      statLocal: "Local Service",
      slide1Badge: "UNLIMITED & COMMITMENT-FREE",
      slide1Title: "Unlimited Speed,",
      slide1Title2: "Commitment-Free Internet",
      slide1Desc: "Speeds up to 100 Mbps, unlimited quota and local technical support.",
      slide2Badge: "LOCAL POWER",
      slide2Title: "Ortaca's",
      slide2Title2: "AIR Fiber Infrastructure",
      slide2Desc: "AIR Fiber-to-the-home technology with neighbor-like service.",
      slide3Badge: "CONNECT NOW",
      slide3Title: "Easy Application,",
      slide3Title2: "Fast Connection",
      slide3Desc: "Apply today, get your AIR Fiber internet within 1-3 business days.",
    },
    home: {
      statsTitle: "ÇağrıNET in Numbers",
      statsSubscribers: "Happy Subscribers",
      statsCoverage: "Coverage Area",
      statsUptime: "Uptime",
      statsSupport: "Local Support",
      whyTitle: "Why ÇağrıNET?",
      whySubtitle: "We combine the region's strongest AIR Fiber infrastructure with a local service mindset.",
      why1Title: "True AIR Fiber Infrastructure",
      why1Desc: "With AIR Fiber-to-the-home (FTTH), you actually get the speed we promise.",
      why2Title: "Unlimited Usage",
      why2Desc: "No fair usage quota. Download, stream and play as much as you want.",
      why3Title: "Local Support",
      why3Desc: "No call center mazes. Our team in Ortaca is always by your side.",
      why4Title: "Transparent Pricing",
      why4Desc: "No hidden fees, no surprise increases. You always know what you pay.",
      packagesTitle: "Choose the Right Plan for You",
      packagesSubtitle: "AIR Fiber internet packages for every need and budget.",
      allPackages: "See All Plans",
      servicesTitle: "Our Services",
      servicesSubtitle: "One address for all your residential and corporate connectivity needs.",
      campaignsTitle: "Current Campaigns",
      offerFeat1: "Download speeds up to 100 Mbps",
      offerFeat2: "12-month fixed price guarantee",
      offerFeat3: "No commitment, cancel anytime",
      offerFeat4: "Instant digital approval via e-Government",
      ctaTitle: "Ready to experience the freedom of speed?",
      ctaSubtitle: "Apply today, get your AIR Fiber internet within 1-3 business days.",
      ctaButton: "Apply Now",
    },
    packages: {
      title: "Plans",
      subtitle: "Unlimited AIR Fiber internet packages with commitment options and transparent pricing.",
      perMonth: "/mo",
      popular: "MOST POPULAR",
      select: "Plan Details",
      detailTitle: "Plan Detail",
      detailBack: "Back to Plans",
      detailSpeed: "Connection Speed",
      detailPrice: "Monthly Fee",
      detailFeatures: "Plan Features",
      detailCta: "Apply for This Plan",
      detailSpeedDesc: "Download / Upload Speed",
      detailPriceDesc: "Fixed Monthly Fee Including VAT",
      detailFeaturesDesc: "All benefits included in your plan",
      mbps: "Mbps",
      note: "Prices include VAT. Service is subject to infrastructure availability.",
    },
    services: {
      title: "Services",
      subtitle: "Complete connectivity solutions for your home and business.",
    },
    about: {
      title: "About Us",
      subtitle: "Connecting our region with the internet of the future.",
      storyTitle: "Our Story",
      p1: "ÇAĞRINETWORK İNTERNET İLETİŞİM HABERLEŞME LTD ŞTİ is an internet service provider founded in Ortaca, Muğla, dedicated to providing high-speed and reliable internet access to its region.",
      p2: "Since our founding, we have been bringing modern AIR Fiber infrastructure to areas underserved by major operators, delivering big-city quality internet to every household and business.",
      p3: "With the strength of being a local company, we treat our subscribers like neighbors, not customer numbers. Our technical team operates with same-day response, during business hours support and transparent pricing principles.",
      missionTitle: "Our Mission",
      missionText: "To provide fast, uninterrupted and affordable internet access to every household and business in our region.",
      visionTitle: "Our Vision",
      visionText: "To be the most trusted regional telecommunications company leading the digital transformation of Muğla and its surroundings.",
      valuesTitle: "Our Values",
      value1: "Reliability",
      value1Desc: "We keep our word; we deliver the speed we promise.",
      value2: "Local Roots",
      value2Desc: "We know our region and treat our subscribers like neighbors.",
      value3: "Innovation",
      value3Desc: "We continuously improve our infrastructure and bring the latest technology to our region.",
    },
    blog: {
      title: "Blog & News",
      subtitle: "News, technology guides and announcements from ÇağrıNET.",
      readMore: "Read More",
      back: "All Posts",
      empty: "No posts yet.",
    },
    campaigns: {
      title: "Campaigns",
      subtitle: "Don't miss out on exclusive offers.",
      apply: "Get This Offer",
      empty: "There are no active campaigns at the moment.",
    },
    faq: {
      title: "Frequently Asked Questions",
      subtitle: "Quick answers to your questions.",
      moreTitle: "Couldn't find your answer?",
      moreText: "Our team is available during business hours for all your questions.",
      moreCta: "Contact Us",
    },
    contact: {
      title: "Contact",
      subtitle: "We're here for your questions, applications and support requests.",
      formTitle: "Write to Us",
      name: "Full Name",
      email: "Email",
      phone: "Phone",
      subject: "Subject",
      message: "Your Message",
      send: "Send",
      sending: "Sending...",
      success: "Your message has been sent. We'll get back to you shortly.",
      error: "Message could not be sent. Please try again.",
      infoTitle: "Contact Information",
      addressLabel: "Address",
      phoneLabel: "Phone",
      emailLabel: "Email",
      hoursLabel: "Working Hours",
      hours: "Monday - Saturday: 09:00 - 18:00",
    },
    footer: {
      tagline: "High-speed AIR Fiber internet for Ortaca and its surroundings. Local strength, global speed.",
      quickLinks: "Quick Links",
      services: "Services",
      contact: "Contact",
      rights: "All rights reserved.",
    },
    cookie: {
      title: "We Use Cookies",
      text: "We use cookies to provide a better experience on our website. Under KVKK Law No. 6698 and GDPR, you can accept our use of cookies or manage your settings.",
      policyLink: "Cookie Policy",
      acceptAll: "Accept All",
      reject: "Necessary Only",
      settings: "Settings",
      close: "Close",
      catNecessary: "Necessary Cookies",
      catNecessaryDesc: "Required for the website to function properly. Cannot be disabled.",
      catAnalytics: "Analytics Cookies",
      catAnalyticsDesc: "Used to analyze site usage and improve the experience.",
      catMarketing: "Marketing Cookies",
      catMarketingDesc: "Used to deliver content and ads relevant to your interests.",
      save: "Save Settings",
      poweredBy: "KVKK & GDPR compliant",
    },
    common: {
      loading: "Loading...",
    },
    comingSoon: {
      badge: "UNDER CONSTRUCTION",
      title1: "A Renewed Digital",
      title2: "Experience",
      subtitle:
        "We are carefully crafting our new corporate website. Until it is ready, our services continue without interruption.",
      paymentBtn: "Click to Make a Payment",
      paymentNote: "You will be securely redirected to our online payment portal.",
      contactTitle: "Get in Touch",
      brandTagline: "Ortaca's AIR Fiber backbone — local strength, global speed.",
    },
  },

  ru: {
    nav: {
      home: "Главная",
      packages: "Тарифы",
      services: "Услуги",
      corporate: "О нас",
      campaigns: "Акции",
      blog: "Блог",
      faq: "Вопросы",
      contact: "Контакты",
      online: "Онлайн-услуги",
      applyNow: "Подать заявку",
      applyOnline: "Онлайн-заявка",
      callYou: "Перезвонить вам",
      coverage: "Проверить покрытие",
      individual: "Частное лицо",
      speedTest: "Тест скорости",
      fastActions: "Быстрые действия",
    },
    hero: {
      badge: "ОПТОВОЛОКОННАЯ СЕТЬ ОРТАДЖА",
      title1: "Интернет со",
      title2: "скоростью света.",
      subtitle:
        "Откройте для себя технологию «оптика до дома» с ÇağrıNET. Скорость до 100 Мбит/с, безлимитный трафик и местная техподдержка.",
      ctaPackages: "Смотреть тарифы",
      ctaContact: "Связаться с нами",
      coverageTitle: "Проверить покрытие",
      coveragePlaceholder: "Введите ваш район / адрес...",
      coverageBtn: "Проверить",
      speedTestTitle: "Тест скорости интернета",
      speedTestDesc: "Измерьте реальную скорость соединения",
      speedTestStart: "Начать тест",
      speedTestRunning: "Измерение...",
      speedTestRetry: "Тест заново",
      speedTestDownload: "Загрузка",
      speedTestUpload: "Отдача",
      speedTestPing: "Пинг",
      speedTestJitter: "Джиттер",
      speedTestMbps: "Мбит/с",
      speedTestMs: "мс",
      speedTestLauncher: "Запустить тест скорости",
      speedTestPoweredBy: "На базе Fast.com",
      speedTestNote: "Нажмите, чтобы надёжно и точно измерить реальную скорость интернета.",
      statSpeed: "Максимальная скорость",
      statSupport: "Техподдержка",
      statUptime: "Время работы",
      statLocal: "Местный сервис",
      slide1Badge: "БЕЗЛИМИТ И БЕЗ ОБЯЗАТЕЛЬСТВ",
      slide1Title: "Безлимитная скорость,",
      slide1Title2: "интернет без обязательств",
      slide1Desc: "Скорость до 100 Мбит/с, безлимитный трафик и местная техподдержка.",
      slide2Badge: "МЕСТНАЯ СИЛА",
      slide2Title: "Волоконная",
      slide2Title2: "инфраструктура Ортаджа",
      slide2Desc: "Оптика до дома и сервис как для соседей.",
      slide3Badge: "ПОДКЛЮЧАЙТЕСЬ",
      slide3Title: "Быстрая заявка,",
      slide3Title2: "быстрое подключение",
      slide3Desc: "Подайте заявку сегодня — подключим за 1-3 рабочих дня.",
    },
    home: {
      statsTitle: "ÇağrıNET в цифрах",
      statsSubscribers: "Довольных абонентов",
      statsCoverage: "Зона покрытия",
      statsUptime: "Время работы",
      statsSupport: "Местная поддержка",
      whyTitle: "Почему ÇağrıNET?",
      whySubtitle: "Мы сочетаем сильнейшую оптоволоконную инфраструктуру региона с местным сервисом.",
      why1Title: "Настоящее оптоволокно",
      why1Desc: "С технологией FTTH вы реально получаете обещанную скорость.",
      why2Title: "Безлимитный трафик",
      why2Desc: "Никаких квот. Скачивайте, смотрите и играйте сколько хотите.",
      why3Title: "Местная поддержка",
      why3Desc: "Никаких лабиринтов колл-центров. Наша команда в Ортадже всегда рядом.",
      why4Title: "Прозрачные цены",
      why4Desc: "Без скрытых платежей и неожиданных повышений. Вы всегда знаете, за что платите.",
      packagesTitle: "Выберите подходящий тариф",
      packagesSubtitle: "Пакеты оптоволоконного интернета на любые потребности и бюджет.",
      allPackages: "Все тарифы",
      servicesTitle: "Наши услуги",
      servicesSubtitle: "Все решения для подключения дома и бизнеса в одном месте.",
      campaignsTitle: "Текущие акции",
      offerFeat1: "Скорость загрузки до 100 Мбит/с",
      offerFeat2: "Гарантия фиксированной цены на 12 месяцев",
      offerFeat3: "Без обязательств, отмена в любое время",
      offerFeat4: "Мгновенное цифровое подтверждение через e-Devlet",
      ctaTitle: "Готовы ощутить свободу скорости?",
      ctaSubtitle: "Подайте заявку сегодня — подключим за 1-3 рабочих дня.",
      ctaButton: "Подать заявку",
    },
    packages: {
      title: "Тарифы",
      subtitle: "Безлимитные пакеты оптоволоконного интернета с прозрачными ценами.",
      perMonth: "/мес",
      popular: "САМЫЙ ПОПУЛЯРНЫЙ",
      select: "Детали тарифа",
      detailTitle: "Детали тарифа",
      detailBack: "Назад к тарифам",
      detailSpeed: "Скорость соединения",
      detailPrice: "Ежемесячная плата",
      detailFeatures: "Особенности тарифа",
      detailCta: "Подать заявку",
      detailSpeedDesc: "Скорость загрузки / отдачи",
      detailPriceDesc: "Фиксированная плата с НДС",
      detailFeaturesDesc: "Все преимущества вашего тарифа",
      mbps: "Мбит/с",
      note: "Цены включают НДС. Услуга зависит от наличия инфраструктуры.",
    },
    services: {
      title: "Услуги",
      subtitle: "Полные решения для подключения вашего дома и бизнеса.",
    },
    about: {
      title: "О нас",
      subtitle: "Соединяем наш регион с интернетом будущего.",
      storyTitle: "Наша история",
      p1: "ÇAĞRINETWORK İNTERNET İLETİŞİM HABERLEŞME LTD ŞTİ — интернет-провайдер, основанный в Ортадже (Мугла), цель которого — обеспечить регион высокоскоростным и надёжным интернетом.",
      p2: "С момента основания мы прокладываем современную оптоволоконную инфраструктуру в районы, недостаточно охваченные крупными операторами, обеспечивая интернет столичного качества каждому дому и бизнесу.",
      p3: "Будучи местной компанией, мы относимся к абонентам как к соседям, а не как к номерам клиентов. Наша техническая команда работает по принципам реагирования в тот же день, поддержки в рабочие часы и прозрачных цен.",
      missionTitle: "Наша миссия",
      missionText: "Обеспечить быстрый, бесперебойный и доступный интернет каждому дому и бизнесу в нашем регионе.",
      visionTitle: "Наше видение",
      visionText: "Стать самой надёжной региональной телекоммуникационной компанией, ведущей цифровую трансформацию Муглаа и окрестностей.",
      valuesTitle: "Наши ценности",
      value1: "Надёжность",
      value1Desc: "Мы держим слово и обеспечиваем обещанную скорость.",
      value2: "Местные корни",
      value2Desc: "Мы знаем свой регион и относимся к абонентам как к соседям.",
      value3: "Инновации",
      value3Desc: "Мы постоянно улучшаем инфраструктуру и привносим новейшие технологии.",
    },
    blog: {
      title: "Блог и новости",
      subtitle: "Новости, технологические гайды и объявления от ÇağrıNET.",
      readMore: "Читать далее",
      back: "Все статьи",
      empty: "Статей пока нет.",
    },
    campaigns: {
      title: "Акции",
      subtitle: "Не упустите эксклюзивные предложения.",
      apply: "Воспользоваться акцией",
      empty: "Сейчас нет активных акций.",
    },
    faq: {
      title: "Часто задаваемые вопросы",
      subtitle: "Быстрые ответы на ваши вопросы.",
      moreTitle: "Не нашли ответ?",
      moreText: "Наша команда доступна в рабочие часы для любых вопросов.",
      moreCta: "Связаться с нами",
    },
    contact: {
      title: "Контакты",
      subtitle: "Мы здесь для ваших вопросов, заявок и запросов в поддержку.",
      formTitle: "Напишите нам",
      name: "Имя и фамилия",
      email: "Эл. почта",
      phone: "Телефон",
      subject: "Тема",
      message: "Ваше сообщение",
      send: "Отправить",
      sending: "Отправка...",
      success: "Ваше сообщение отправлено. Мы скоро свяжемся с вами.",
      error: "Не удалось отправить сообщение. Попробуйте ещё раз.",
      infoTitle: "Контактная информация",
      addressLabel: "Адрес",
      phoneLabel: "Телефон",
      emailLabel: "Эл. почта",
      hoursLabel: "Часы работы",
      hours: "Понедельник - Суббота: 09:00 - 18:00",
    },
    footer: {
      tagline: "Высокоскоростной оптоволоконный интернет для Ортаджа и окрестностей. Местная сила, глобальная скорость.",
      quickLinks: "Быстрые ссылки",
      services: "Услуги",
      contact: "Контакты",
      rights: "Все права защищены.",
    },
    cookie: {
      title: "Мы используем файлы cookie",
      text: "Мы используем файлы cookie для улучшения вашего опыта на сайте. В соответствии с законом № 6698 (KVKK) и GDPR вы можете принять использование cookie или управлять настройками.",
      policyLink: "Политика cookie",
      acceptAll: "Принять все",
      reject: "Только необходимые",
      settings: "Настройки",
      close: "Закрыть",
      catNecessary: "Необходимые cookie",
      catNecessaryDesc: "Требуются для корректной работы сайта. Нельзя отключить.",
      catAnalytics: "Аналитические cookie",
      catAnalyticsDesc: "Используются для анализа использования сайта и улучшения опыта.",
      catMarketing: "Маркетинговые cookie",
      catMarketingDesc: "Используются для показа релевантного контента и рекламы.",
      save: "Сохранить настройки",
      poweredBy: "Соответствие KVKK и GDPR",
    },
    common: {
      loading: "Загрузка...",
    },
    comingSoon: {
      badge: "В РАЗРАБОТКЕ",
      title1: "Обновлённый цифровой",
      title2: "опыт",
      subtitle:
        "Мы тщательно создаём наш новый корпоративный сайт. До его запуска наши услуги продолжаются без перерыва.",
      paymentBtn: "Нажмите, чтобы оплатить",
      paymentNote: "Вы будете безопасно перенаправлены на наш онлайн-портал оплаты.",
      contactTitle: "Связаться с нами",
      brandTagline: "Волоконная инфраструктура Ортаджа — местная сила, глобальная скорость.",
    },
  },

  ar: {
    nav: {
      home: "الرئيسية",
      packages: "الباقات",
      services: "الخدمات",
      corporate: "من نحن",
      campaigns: "العروض",
      blog: "المدونة",
      faq: "الأسئلة الشائعة",
      contact: "اتصل بنا",
      online: "الخدمات الإلكترونية",
      applyNow: "قدّم الآن",
      applyOnline: "طلب عبر الإنترنت",
      callYou: "نتصل بك",
      coverage: "تحقق من التغطية",
      individual: "أفراد",
      speedTest: "اختبار السرعة",
      fastActions: "إجراءات سريعة",
    },
    hero: {
      badge: "البنية التحتية للألياف في أورتاجا",
      title1: "إنترنت",
      title2: "بسرعة الضوء.",
      subtitle:
        "اكتشف تقنية الألياف حتى المنزل مع ÇağrıNET. سرعات تصل إلى 100 ميجابت، استخدام غير محدود ودعم فني محلي.",
      ctaPackages: "تصفح الباقات",
      ctaContact: "تواصل معنا",
      coverageTitle: "تحقق من التغطية",
      coveragePlaceholder: "أدخل الحي / العنوان...",
      coverageBtn: "تحقق",
      speedTestTitle: "اختبار سرعة الإنترنت",
      speedTestDesc: "اقسر سرعة اتصالك الحقيقية",
      speedTestStart: "ابدأ الاختبار",
      speedTestRunning: "جارٍ القياس...",
      speedTestRetry: "اختبر مرة أخرى",
      speedTestDownload: "التنزيل",
      speedTestUpload: "الرفع",
      speedTestPing: "التأخير",
      speedTestJitter: "التذبذب",
      speedTestMbps: "ميجابت",
      speedTestMs: "مللي ثانية",
      speedTestLauncher: "ابدأ اختبار السرعة",
      speedTestPoweredBy: "بدعم من Fast.com",
      speedTestNote: "اضغط لقياس سرعة الإنترنت الحقيقية بدقة وموثوقية.",
      statSpeed: "السرعة القصوى",
      statSupport: "الدعم الفني",
      statUptime: "وقت التشغيل",
      statLocal: "خدمة محلية",
      slide1Badge: "غير محدود وبدون التزام",
      slide1Title: "سرعة غير محدودة،",
      slide1Title2: "إنترنت بدون التزام",
      slide1Desc: "سرعات تصل إلى 100 ميجابت، استخدام غير محدود ودعم محلي.",
      slide2Badge: "قوة محلية",
      slide2Title: "البنية التحتية",
      slide2Title2: "للألياف في أورتاجا",
      slide2Desc: "ألياف حتى المنزل بخدمة كالجيران.",
      slide3Badge: "اتصل الآن",
      slide3Title: "طلب سريع،",
      slide3Title2: "اتصال سريع",
      slide3Desc: "قدّم طلبك اليوم واحصل على إنترنت الألياف خلال 1-3 أيام عمل.",
    },
    home: {
      statsTitle: "ÇağrıNET بالأرقام",
      statsSubscribers: "مشترك سعيد",
      statsCoverage: "منطقة التغطية",
      statsUptime: "وقت التشغيل",
      statsSupport: "دعم محلي",
      whyTitle: "لماذا ÇağrıNET؟",
      whySubtitle: "نجمع بين أقوى بنية تحتية للألياف في المنطقة وعقلية الخدمة المحلية.",
      why1Title: "بنية ألياف حقيقية",
      why1Desc: "مع الألياف حتى المنزل (FTTH)، تحصل فعلًا على السرعة التي نعد بها.",
      why2Title: "استخدام غير محدود",
      why2Desc: "لا حصص استخدام عادل. حمّل وشاهد والعب كما تشاء.",
      why3Title: "دعم محلي",
      why3Desc: "لا متاهات مراكز اتصال. فريقنا في أورتاجا دائمًا بجانبك.",
      why4Title: "أسعار شفافة",
      why4Desc: "لا رسوم خفية ولا زيادات مفاجئة. تعرف دائمًا ما تدفعه.",
      packagesTitle: "اختر الباقة المناسبة لك",
      packagesSubtitle: "باقات إنترنت الألياف لكل احتياج وميزانية.",
      allPackages: "عرض جميع الباقات",
      servicesTitle: "خدماتنا",
      servicesSubtitle: "عنوان واحد لجميع احتياجات الاتصال المنزلية والتجارية.",
      campaignsTitle: "العروض الحالية",
      offerFeat1: "سرعة تحميل تصل إلى 100 ميجابت",
      offerFeat2: "ضمان سعر ثابت لمدة 12 شهرًا",
      offerFeat3: "بدون التزام، ألغِ في أي وقت",
      offerFeat4: "موافقة رقمية فورية عبر e-Devlet",
      ctaTitle: "لا تقدم شركتنا أي خدمة اتصالات إلكترونية في إطار خدمة تشغيل البنية التحتية (AİH).",
      ctaSubtitle: "قدّم طلبك اليوم واحصل على إنترنت الألياف خلال 1-3 أيام عمل.",
      ctaButton: "قدّم الآن",
    },
    packages: {
      title: "الباقات",
      subtitle: "باقات إنترنت ألياف غير محدودة بأسعار شفافة وخيارات التزام.",
      perMonth: "/شهر",
      popular: "الأكثر شعبية",
      select: "تفاصيل الباقة",
      detailTitle: "تفاصيل الباقة",
      detailBack: "العودة إلى الباقات",
      detailSpeed: "سرعة الاتصال",
      detailPrice: "الرسوم الشهرية",
      detailFeatures: "ميزات الباقة",
      detailCta: "قدم طلبًا لهذه الباقة",
      detailSpeedDesc: "سرعة التحميل / الرفع",
      detailPriceDesc: "رسوم شهرية ثابتة شاملة الضرائب",
      detailFeaturesDesc: "جميع المزايا المضمنة في باقتك",
      mbps: "ميجابت",
      note: "الأسعار تشمل الضرائب. الخدمة تخضع لتوفر البنية التحتية.",
    },
    services: {
      title: "الخدمات",
      subtitle: "حلول اتصال متكاملة لمنزلك وعملك.",
    },
    about: {
      title: "من نحن",
      subtitle: "نربط منطقتنا بإنترنت المستقبل.",
      storyTitle: "قصتنا",
      p1: "شركة ÇAĞRINETWORK İNTERNET İLETİŞİM HABERLEŞME LTD ŞTİ هي مزود خدمة إنترنت تأسست في أورتاجا بمغلا، وتكرّس جهودها لتوفير وصول إنترنت عالي السرعة وموثوق لمنطقتها.",
      p2: "منذ تأسيسنا، ننقل البنية التحتية الحديثة للألياف إلى المناطق التي لم تخدمها كبرى الشركات بشكل كافٍ، ونقدم إنترنت بجودة المدن الكبرى لكل منزل وشركة.",
      p3: "بقوة كوننا شركة محلية، نعامل مشتركينا كجيران وليس كأرقام عملاء. يعمل فريقنا الفني بمبادئ الاستجابة في نفس اليوم والدعم خلال ساعات العمل والأسعار الشفافة.",
      missionTitle: "مهمتنا",
      missionText: "توفير وصول إنترنت سريع ومستمر وبأسعار معقولة لكل منزل وشركة في منطقتنا.",
      visionTitle: "رؤيتنا",
      visionText: "أن نكون شركة الاتصالات الإقليمية الأكثر موثوقية التي تقود التحول الرقمي في مغلا وما حولها.",
      valuesTitle: "قيمنا",
      value1: "الموثوقية",
      value1Desc: "نفي بوعدنا ونقدم السرعة التي نعد بها.",
      value2: "الجذور المحلية",
      value2Desc: "نعرف منطقتنا ونعامل مشتركينا كجيران.",
      value3: "الابتكار",
      value3Desc: "نطور بنيتنا التحتية باستمرار وننقل أحدث التقنيات إلى منطقتنا.",
    },
    blog: {
      title: "المدونة والأخبار",
      subtitle: "أخبار وأدلة تقنية وإعلانات من ÇağrıNET.",
      readMore: "اقرأ المزيد",
      back: "جميع المقالات",
      empty: "لا توجد مقالات بعد.",
    },
    campaigns: {
      title: "العروض",
      subtitle: "لا تفوّت العروض الحصرية.",
      apply: "استفد من العرض",
      empty: "لا توجد عروض نشطة حاليًا.",
    },
    faq: {
      title: "الأسئلة الشائعة",
      subtitle: "إجابات سريعة على أسئلتك.",
      moreTitle: "لم تجد إجابتك؟",
      moreText: "فريقنا متاح خلال ساعات العمل لجميع أسئلتك.",
      moreCta: "تواصل معنا",
    },
    contact: {
      title: "اتصل بنا",
      subtitle: "نحن هنا لأسئلتك وطلباتك واستفسارات الدعم.",
      formTitle: "اكتب لنا",
      name: "الاسم الكامل",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      subject: "الموضوع",
      message: "رسالتك",
      send: "إرسال",
      sending: "جارٍ الإرسال...",
      success: "تم إرسال رسالتك بنجاح. سنرد عليك قريبًا.",
      error: "تعذر إرسال الرسالة. حاول مرة أخرى.",
      infoTitle: "معلومات الاتصال",
      addressLabel: "العنوان",
      phoneLabel: "الهاتف",
      emailLabel: "البريد الإلكتروني",
      hoursLabel: "ساعات العمل",
      hours: "الاثنين - السبت: 09:00 - 18:00",
    },
    footer: {
      tagline: "إنترنت ألياف عالي السرعة لأورتاجا وما حولها. قوة محلية، سرعة عالمية.",
      quickLinks: "روابط سريعة",
      services: "الخدمات",
      contact: "اتصل بنا",
      rights: "جميع الحقوق محفوظة.",
    },
    cookie: {
      title: "نستخدم ملفات تعريف الارتباط (الكوكيز)",
      text: "نستخدم ملفات تعريف الارتباط لتقديم تجربة أفضل على موقعنا. بموجب قانون KVKK رقم 6698 وGDPR، يمكنك قبول استخدامنا للكوكيز أو إدارة إعداداتك.",
      policyLink: "سياسة الكوكيز",
      acceptAll: "قبول الكل",
      reject: "الضرورية فقط",
      settings: "الإعدادات",
      close: "إغلاق",
      catNecessary: "الكوكيز الضرورية",
      catNecessaryDesc: "مطلوبة لتشغيل الموقع بشكل صحيح. لا يمكن تعطيلها.",
      catAnalytics: "كوكيز التحليلات",
      catAnalyticsDesc: "تُستخدم لتحليل استخدام الموقع وتحسين التجربة.",
      catMarketing: "كوكيز التسويق",
      catMarketingDesc: "تُستخدم لتقديم محتوى وإعلانات تتوافق مع اهتماماتك.",
      save: "حفظ الإعدادات",
      poweredBy: "متوافقة مع KVKK و GDPR",
    },
    common: {
      loading: "جارٍ التحميل...",
    },
    comingSoon: {
      badge: "تحت الإنشاء",
      title1: "تجربة رقمية",
      title2: "متجدّدة",
      subtitle:
        "نعمل بعناية على موقعنا الإلكتروني الجديد. وحتى جاهزيته، تستمر خدماتنا دون انقطاع.",
      paymentBtn: "اضغط لإتمام الدفع",
      paymentNote: "سيتم تحويلك بأمان إلى بوابة الدفع الإلكتروني الخاصة بنا.",
      contactTitle: "تواصل معنا",
      brandTagline: "البنية التحتية الليفية لسيليفكي — قوة محلية، سرعة عالمية.",
    },
  },
};

